export default __webpack_public_path__ + "static/awarepath_medium_1-dbbe40bcb3af0def4c3fb73140766558.png";